export enum Role {
    ADMIN = "ADMIN",
    USER = "USER",
    COREMEMBERS = "COREMEMBERS",
    TEAM_LEAD = "TEAM_LEAD",
    ASSISTANT_TEAM_LEAD = "ASSISTANT_TEAM_LEAD"
}